<a class="c-blue-1" *ngIf="(vehicleToDisplay | async) as vehicle; else noData" routerLink="/fleet/vehicle/{{vehicle.id}}"  [queryParams]="{fid: fleetId}" style="cursor: pointer">{{vehicle | vehicleName}}</a>
<ng-template #noData></ng-template>
